import { ComplexEnum } from '../../../utils/complexEnum'
import {
  ConstructionAdminSubmittal,
  FieldDesignChange,
  IdentifiedFieldIssue,
  Issue,
  RequestForInformation,
  EngineeringJudgement,
  ConcreteMixDesign,
  AsphaltMixDesign,
  DesignSubmittal,
} from './instances'

export type CustomFieldClassTypeItem =
  | typeof FieldDesignChange
  | typeof IdentifiedFieldIssue
  | typeof RequestForInformation
  | typeof Issue
  | typeof ConstructionAdminSubmittal
  | typeof EngineeringJudgement
  | typeof ConcreteMixDesign
  | typeof AsphaltMixDesign
  | typeof DesignSubmittal
type ID = CustomFieldClassTypeItem['id']
class CustomFieldClassTypeEnum extends ComplexEnum<
  'CustomFieldClassType',
  CustomFieldClassTypeItem,
  ID
> {
  readonly typename = 'CustomFieldClassType'
  readonly FieldDesignChange = FieldDesignChange
  readonly IdentifiedFieldIssue = IdentifiedFieldIssue
  readonly RequestForInformation = RequestForInformation
  readonly Issue = Issue
  readonly ConstructionAdminSubmittal = ConstructionAdminSubmittal
  readonly EngineeringJudgement = EngineeringJudgement
  readonly ConcreteMixDesign = ConcreteMixDesign
  readonly AsphaltMixDesign = AsphaltMixDesign
  readonly DesignSubmittal = DesignSubmittal
  get values() {
    return [
      this.FieldDesignChange,
      this.RequestForInformation,
      this.IdentifiedFieldIssue,
      this.Issue,
      this.ConstructionAdminSubmittal,
      this.EngineeringJudgement,
      this.ConcreteMixDesign,
      this.AsphaltMixDesign,
      this.DesignSubmittal,
    ]
  }
  get classTypes() {
    return this.map(({ classType }) => classType)
  }
  fromClassType(classType: string) {
    return this.find((value) => value.classType === classType)
  }
  fromClassTypeOrFail(classType: string) {
    return this.orFail(this.fromClassType(classType), classType)
  }
}

/**
 * a {@link complexEnum} describing which entities support custom fields
 *
 * as we add support for more entities, we'll add them to this enum
 */
export const CustomFieldClassType = new CustomFieldClassTypeEnum()
